import {AppBar, Toolbar, Typography} from '@mui/material';

export default function Header() {

    return (
      <>
        <AppBar position="relative">
        <Toolbar>
          <Typography variant="h6" color="inherit" noWrap>
             배송 조회
          </Typography>
        </Toolbar>
      </AppBar>
      </>
  );
}
